import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DiscountType } from "@/types/discount";

type CouponState = {
  couponCode: string;
  couponDiscountValue: number;
  couponDiscountType: DiscountType | undefined;
};

const initialState: CouponState = {
  couponCode: "",
  couponDiscountValue: 0,
  couponDiscountType: undefined,
};

export const couponSlice = createSlice({
  name: "coupon",
  initialState,
  reducers: {
    setCoupon: (state, action: PayloadAction<CouponState>) => {
      state.couponCode = action.payload.couponCode;
      state.couponDiscountValue = action.payload.couponDiscountValue;
      state.couponDiscountType = action.payload.couponDiscountType;

      if (typeof window !== "undefined") {
        localStorage.setItem("coupon_data", JSON.stringify(action.payload));
      }
    },
    clearCoupon: (state) => {
      state.couponCode = "";
      state.couponDiscountValue = 0;
      state.couponDiscountType = undefined;

      if (typeof window !== "undefined") {
        localStorage.removeItem("coupon_data");
      }
    },
    initializeCoupon: (state) => {
      if (typeof window !== "undefined") {
        const data = localStorage.getItem("coupon_data");
        if (data) {
          try {
            const parsed = JSON.parse(data);
            state.couponCode = parsed.couponCode;
            state.couponDiscountValue = parsed.couponDiscountValue;
            state.couponDiscountType = parsed.couponDiscountType;
          } catch (e) {
            console.error("Failed to parse coupon data", e);
          }
        }
      }
    },
  },
});

export const { setCoupon, clearCoupon, initializeCoupon } = couponSlice.actions;
export default couponSlice.reducer;
